import React, { useState, useEffect } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { HiExternalLink } from "react-icons/hi";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

import msbcLogo from "../assets/images/msbcLogo.svg";
import stripeLogo from "../assets/images/stripeLogo.svg";
import arrowIcon from "../assets/images/arrowIcon.svg";

import { connectedMsbc, fetchStatus } from "../store/slice/preferenceSlice";
import { getUrl } from "../helpers/url";

import { cmsConstructor } from "../helpers/cms/cmsConstructor";
import { useCmsHook } from "../helpers/cms/cmsHook";
import CmsEditBanner from "../helpers/cms/CmsEditBanner";

function Authentication() {
  const { setCmsInstance, cmsInstance } = useCmsHook();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [disconnectLoading, setDisconnectLoading] = useState(false);
  const { isMsbcConnected } = useSelector((state) => state.preference);

  /**
   * This function is used for storing the msbc creds in Dynamo DB by posting posting data to AWS lambda function
   */
  const onConnectMsbc = async () => {
    try {
      const account = searchParams.get("account");
      window.open(
        `${getUrl("REACT_APP_STRIPE_OAUTH")}?account=${account}&path=${
          window.location.pathname.split("/")[1]
        }`,
        "_self"
      );
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      toast.error(errorMessage);
    }
  };

  /**
   * This function is used for removing the msbc creds from DynamoDB
   */
  const onDisconnectMsbc = async () => {
    try {
      setDisconnectLoading(true);
      const account = searchParams.get("account");
      await axios.post(getUrl("REACT_APP_DISCONNECT_MSBC"), { account });
      dispatch(connectedMsbc({ isConnected: false }));
      toast.success(
        cmsInstance &&
          cmsInstance.sendData().cmsContent.notifications.authentication
            .successContent.disconnectMsbc.message
      );
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      toast.error(errorMessage);
    } finally {
      setDisconnectLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const status = searchParams.get("status");
    const account = searchParams.get("account");
    if (status && status === "successfull" && account) {
      // navigate(
      //   `${window.location.pathname}?account=${account}&tenantId=${tenantId}`
      // );
      dispatch(connectedMsbc({ isConnected: true }));
      toast.success(
        cmsInstance &&
          cmsInstance.sendData().cmsContent.notifications.authentication
            .successContent.connectMsbc.message
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const account = searchParams.get("account");
    if (account) {
      dispatch(fetchStatus(account));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/oauth") {
      const fetchCmsInstance = async () => {
        const cmsObj = await cmsConstructor();
        setCmsInstance(cmsObj);
      };
      fetchCmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-bg-container w-100">
      {window.location.pathname === "/oauth" && (
        <div className="d-flex flex-row justify-content-center">
          <CmsEditBanner />
        </div>
      )}
      <div className="page-bg-container d-flex flex-column justify-content-center align-items-center">
        <Row className="d-flex flex-row justify-content-center align-items-center h-100 w-100 px-2">
          <Col sm={10} md={6} lg={3} className="oauth-card px-0">
            <div>
              <div className="oauth-card-heading-container">
                {cmsInstance &&
                  cmsInstance.showRichText(
                    "cmsContent.authentication.heading",
                    "oauth-card-heading"
                  )}
              </div>
              <div className="px-4 pt-5">
                <div className="oauth-card-logos-container">
                  <img src={stripeLogo} alt="stripe logo" />
                  <img src={arrowIcon} alt="arrow icon" className="px-4" />
                  <img src={msbcLogo} alt="msbc logo" />
                </div>
                {isMsbcConnected &&
                  cmsInstance &&
                  cmsInstance.showRichText(
                    "cmsContent.authentication.connectText",
                    "oauth-card-para mt-2"
                  )}
                {!isMsbcConnected &&
                  cmsInstance &&
                  cmsInstance.showRichText(
                    "cmsContent.authentication.disconnectText",
                    "oauth-card-para mt-2"
                  )}
              </div>
            </div>

            <div className="d-flex flex-column p-4">
              <Button
                className="oauth-card-connect"
                disabled={isMsbcConnected}
                onClick={() => onConnectMsbc()}
              >
                <span>Connect Business Central</span>
                <HiExternalLink className="oauth-card-hyperlink" size={17} />
              </Button>
              {isMsbcConnected && (
                <Button
                  className="mt-2 oauth-card-disconnect"
                  onClick={() => onDisconnectMsbc()}
                >
                  {disconnectLoading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <span>Disconnect Business Central</span>
                  )}
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Authentication;
